import {Injectable} from "@angular/core";
import * as lodash from "lodash";
import { CorrespondantDto } from "../resources/auth/resources.auth";


@Injectable()
export class CorrespondantStore {

  private correspondants: Array<CorrespondantDto>;
  private correspondant: CorrespondantDto;

  constructor() {
  }

  resetCorrespondant() {
    this.correspondant = null;
  }

  hasTag(tag: string) {
    if (this.correspondant != null) {
      return lodash.indexOf(this.correspondant.tags, tag) != -1;
    } else {
      return false;
    }
  }

  setCorrespondant(correspondant: CorrespondantDto) {
    this.correspondant = correspondant;
  }

  getCorrespondant(): CorrespondantDto {
    return this.correspondant;
  }

  getCorrespondants(): Array<CorrespondantDto> {
    return this.correspondants;
  }

  setCorrespondants(correspondants: Array<CorrespondantDto>) {
    this.correspondants = correspondants;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/store/correspondant.store.ts